// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.multi-role-switch-container {
  display: flex;
  flex-direction: column;
}
.multi-role-switch-container .role-switch-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
}
.multi-role-switch-container .role-switch-item:last-child {
  border-bottom: none;
}
.multi-role-switch-container .role-switch-item .role-switch-content {
  display: flex;
  flex-direction: column;
}
.multi-role-switch-container .role-switch-item .role-switch-content .role-label {
  font-weight: 500;
  color: #333;
}
.multi-role-switch-container .role-switch-item .role-switch-content .role-switch-hint {
  font-size: 0.8rem;
  color: #666;
  margin-top: 4px;
  background-color: #f0f0f0;
  padding: 4px 8px;
  border-radius: 4px;
  display: inline-block;
}
.multi-role-switch-container .role-switch-item.role-switch-disabled {
  opacity: 0.6;
}`, "",{"version":3,"sources":["webpack://./src/components/MultiRoleSwitch/MultiRoleSwitch.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;AACJ;AACI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AACR;AAEQ;EACI,mBAAA;AAAZ;AAGQ;EACI,aAAA;EACA,sBAAA;AADZ;AAGY;EACI,gBAAA;EACA,WAAA;AADhB;AAIY;EACI,iBAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AAFhB;AAMQ;EACI,YAAA;AAJZ","sourcesContent":[".multi-role-switch-container {\n    display: flex;\n    flex-direction: column;\n    \n    .role-switch-item {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 12px 0;\n        // border-bottom: 1px solid #e0e0e0;\n        \n        &:last-child {\n            border-bottom: none;\n        }\n        \n        .role-switch-content {\n            display: flex;\n            flex-direction: column;\n            \n            .role-label {\n                font-weight: 500;\n                color: #333;\n            }\n            \n            .role-switch-hint {\n                font-size: 0.8rem;\n                color: #666;\n                margin-top: 4px;\n                background-color: #f0f0f0;\n                padding: 4px 8px;\n                border-radius: 4px;\n                display: inline-block;\n            }\n        }\n        \n        &.role-switch-disabled {\n            opacity: 0.6;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
